import { ExpandLess, ExpandMore, SaveAlt } from '@mui/icons-material';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import MenuItem from 'app/shared/layout/menus/menu-item';
import React from 'react';
import { Translate } from 'react-jhipster';

export interface IFifthWheel {
  index: number;
  onExpand: (index: number) => void;
  isExpanded: boolean;
  setOpen: (value: boolean) => void;
  drawerIsOpen: boolean;
}

export const FifthWheel = (props: IFifthWheel) => {
  const initialTheme = localStorage.getItem('USER_THEME') as 'light' | 'dark' | null;

  return (
    <>
      <Tooltip title={props.drawerIsOpen ? '' : <Translate contentKey="global.menu.entities.fifthWheel">FifthWheel</Translate>} placement="right">
        <ListItemButton
          id="fifth-wheel-button"
          onClick={() => props.onExpand(props.index)}
          sx={{
            pl: { xs: '18px', md: '32px' },
            backgroundImage: props.isExpanded
              ? initialTheme === 'dark'
                ? 'linear-gradient(rgba(6, 13, 31, 0.9), rgba(6, 13, 31, 0.9))'
                : 'linear-gradient(rgb(226,226,226), rgb(226,226,226))'
              : 'none',
          }}
        >
          <ListItemIcon>
            <SaveAlt />
          </ListItemIcon>
          <ListItemText
            primary={<Translate contentKey="global.menu.entities.fifthWheel">FifthWheel</Translate>}
            primaryTypographyProps={{
              fontFamily: 'Public Sans',
              fontWeight: props.isExpanded ? '600' : '400',
              fontSize: '14px',
            }}
            sx={{ opacity: open ? 1 : 0 }}
          />
          {props.isExpanded ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </Tooltip>

      <Collapse in={props.isExpanded} timeout="auto" unmountOnExit>
        <List component="div" disablePadding onClick={() => props.setOpen(false)}>
          <MenuItem icon="asterisk" to="/fifth-wheel">
            <Translate contentKey="global.menu.entities.fifthWheel" />
          </MenuItem>
          <MenuItem icon="asterisk" to="/fifth-wheel-connection">
            <Translate contentKey="global.menu.entities.fifthWheelConnection" />
          </MenuItem>
          <MenuItem icon="asterisk" to="/fifth-wheel-history">
            <Translate contentKey="global.menu.entities.fifthWheelHistory" />
          </MenuItem>
        </List>
      </Collapse>
    </>
  );
};
